import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { PATHS } from '../../../../Config/Routing/paths'
import StyledBreadcrumbs from '../../../../Components/StyledBreadcrumbs'
import { PageTitle } from '../../../../Components/PageTitle'
import ArrowBackIcon from '../../icons/ArrowBackIcon'
import injectStyles from 'react-jss'
import { styles } from '../../styles'
import BreadcrumbsSettingsIcon from '../../../../Assets/Images/icons/breadcrumbsSettings'
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/Add'
import Table from '../../components/Table'
import LoadingIndicator from '../../../../Components/LoadingIndicator/LoadingIndicator'
import IntegrationsService from '../../../../Module/IntegrationsService/client'

const headers = [
  {
    key: 'couponNames',
    label: 'Coupon names',
    type: 'name',
  },
  {
    key: 'type',
    label: 'Type',
    type: 'name',
  },
  {
    key: 'storeName',
    label: 'Store Name',
    type: 'name',
  },
  {
    key: 'couponsCreated',
    label: 'Coupons created',
    type: 'name',
  },
  {
    key: 'usedAvailable',
    label: 'Used / Available',
    type: 'name',
  },
  {
    key: 'actions',
    label: 'Actions',
    type: 'actions',
  },
]

const CouponsTable = ({ classes }) => {
  const history = useHistory()

  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState(true)

  const onBack = () => {
    history.push(`${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}`)
  }

  const getData = async () => {
    let cards = []

    const integrations = await IntegrationsService.readIntegrations()
    for (const integration of integrations) {
      if (integration) {
        const coupons = await IntegrationsService.readCoupons({
          integrationId: integration.id,
        })
        const formattedCoupons = coupons.map(coupon => {
          return {
            id: coupon.id,
            couponNames: `${coupon.name} (${
              coupon.isActive ? 'ACTIVE' : 'INACTIVE'
            })`,
            type: coupon.type,
            storeName: integration.id,
            couponsCreated: coupon.codesCount,
            usedAvailable: `${coupon.useCount}/${coupon.codesCount}`,
            actions: [
              {
                id: 1,
                name: 'Download CSV',
                onClick: () => {
                  alert('WIP')
                },
              },
              {
                id: 2,
                name: 'Deactivate',
                onClick: () => {
                  alert('WIP')
                },
                style: {
                  color: '#004360',
                },
              },
            ],
          }
        })
        cards = [...cards, ...formattedCoupons]
      }
    }

    return cards
  }

  const fetchData = async () => {
    setIsLoading(true)
    const data = await getData()
    setData(data)
    setIsLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [])

  const onAddCoupon = () => {
    const urlSearchParams = new URLSearchParams(history.location.search)
    const redirectURL = urlSearchParams.get('redirectURL')
    const newUrl = `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}${
      PATHS.clientSettings.coupons
    }${PATHS.clientSettings.createCoupon}${
      redirectURL ? `?redirectURL=${redirectURL}` : ''
    }`

    history.push(newUrl)
  }

  return (
    <div className={classes.container}>
      <StyledBreadcrumbs
        icon={<BreadcrumbsSettingsIcon />}
        breadcrumbs={[
          {
            link: `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}`,
            label: 'Settings',
          },
          {
            label: 'Coupons',
          },
        ]}
      />
      <div className={classes.titleWrap}>
        <PageTitle className={classes.title}>
          <div className={classes.back} onClick={onBack}>
            <ArrowBackIcon />
          </div>
          <div>Select or create coupons</div>
        </PageTitle>
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={onAddCoupon}
          className={classes.button}
        >
          Create coupon
        </Button>
      </div>
      <div className={classes.description} />
      {isLoading ? (
        <LoadingIndicator style={{ height: '42vh' }} />
      ) : (
        <Table headers={headers} data={data} cypress_id="couponsTable" />
      )}
    </div>
  )
}

export default injectStyles(styles)(CouponsTable)
